export default __webpack_public_path__ + "static/media/icon__10.30840e24.svg";